<script setup>
import { ref, watch, onBeforeUnmount } from 'vue';
import 'bootstrap-datepicker';
import $ from 'jquery';
import getDatePickerConfig from "JIX/jix_datepicker.js";

let props = defineProps({
    modelValue: {
        type: String,
        required: false,
        default: '',
    },
    dataFormat: {
        type: String,
        required: false,
        default: 'yyyymmdd',
    },
    options: {
        type: Object,
        default: () => ({}),
    },
});

const emit = defineEmits(['update:modelValue']);

const root = ref();

watch([root, () => props.dateFormat, () => props.options], ([newRoot], [oldRoot]) => {
    if (oldRoot) {
        destroy(oldRoot);
    }
    if (newRoot) {
        const $datepicker = $(newRoot);
        const datepicker_config = getDatePickerConfig(root.value, { format: props.dataFormat, ...props.options });
        if ($datepicker.closest('.modal-dialog').length) {
            datepicker_config.container = $datepicker.closest('.modal-body, .modal-content');
        }
        $datepicker.datepicker(datepicker_config).on('changeDate', handleChange);
    }
});

onBeforeUnmount(() => destroy(root.value));

watch(() => props.modelValue, (val) => $(root.value).datepicker('update', val));

function destroy(rootEl) {
    $(rootEl).off('changeDate', handleChange).datepicker('destroy');
}

function handleChange(event) {
    emit('update:modelValue', event.format());
}

</script>

<template>
    <input
        ref="root"
        type="text"
        autocomplete="off"
        class="form-control"
        :value="modelValue"
        @change="emit('update:modelValue', $event.target.value)"
    >
</template>
